var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C10.762 0 0 0.100976 0 3.76411C0 4.26933 0.227327 4.6988 0.581006 5.07784L9.57467 14.8294V19.9325C9.57467 20.261 9.75159 20.5641 10.0041 20.7662L13.4905 23.1156C13.8947 23.3935 14.4252 23.0904 14.4252 22.6104L14.4253 14.8546L23.419 5.10305C23.7727 4.72418 24 4.29454 24 3.78933C24 0.101007 13.2379 4.50879e-05 12 4.50879e-05L12 0ZM12 5.27999C6.64419 5.27999 3.35999 4.37051 2.45052 3.76411C3.38521 3.15775 6.64424 2.24823 12 2.24823C17.3557 2.24823 20.6399 3.15771 21.5494 3.76411C20.6399 4.37047 17.3557 5.27999 12 5.27999V5.27999Z",
    fill: "#2A2A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1b9d3e36.svg";
export { ForwardRef as ReactComponent };